import React from 'react';
import { Select } from '../ui/basics';

/** The one way to pick a client or a recruiter: a dropdown of the organization's own list, never typed text,
 *  so the same name cannot be saved in different spellings.
 *
 *  lookups  the result of useFetch('lookups/', { organization }); one fetch can feed several dropdowns.
 *  current  the value an existing record already holds. It stays selectable (marked) even when it is no longer on
 *           the list, so editing an old record never silently drops or rewrites its value.
 *  exclude  names to leave out, for example the record being edited when picking who it reports to. */
export default function NameSelect({ kind, lookups, current, exclude = [], placeholder, ...rest }) {
  const { data, loading, error } = lookups;
  const names = data ? (kind === 'client' ? data.clients : data.recruiters.map((r) => r.name)) : [];
  const options = names.filter((n) => !exclude.includes(n)).map((n) => ({ value: n, label: n }));
  if (current && !names.includes(current)) options.unshift({ value: current, label: `${current} (not on the list)` });
  const empty = loading ? 'Loading…' : error ? 'Could not load the list' : placeholder || `Select ${kind}`;
  return <Select options={options} placeholder={empty} {...rest} disabled={rest.disabled || loading || Boolean(error)} />;
}
